import React, { useEffect, useState } from 'react';
import { Alert } from 'antd';
import { blockedNotice, getMyEgress } from '../../services/EgressService';

/**
 * The Logs view's note on the internet requests Flow's egress proxy blocked from the person's sandbox (their plan's
 * internet access: an allowlist or the package registries only; flow-helm-chart docs/egress.md). Nothing while their
 * sandbox has the open internet, nothing was blocked, or the gateway does not say (an older one). What an app can't
 * reach shows up in its logs as a connection error: this says why, and who can change it.
 */
export default function BlockedRequests() {
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    let alive = true;
    getMyEgress(7).then((egress) => { if (alive) { setNotice(blockedNotice(egress)); } }).catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!notice) { return null; }
  return (
    <Alert
      className="svc-logs-blocked"
      closable
      data-testid="svc-logs-blocked"
      description={(
        <div>
          <ul className="svc-logs-blocked-list">
            {notice.hosts.map((h) => <li key={h.host}><span className="sbx-mono">{h.host}</span> · {h.text}</li>)}
            {notice.more > 0 && <li>and {notice.more} more</li>}
          </ul>
          <div>{notice.summary ? `Your plan's internet access: ${notice.summary}. ` : ''}To reach one of these, ask your Flow admin to add it to your plan's allowlist.</div>
        </div>
      )}
      message={notice.title}
      showIcon
      type="warning"
    />
  );
}
